var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jz47ic1l1a",
    d: "M0 0.82L45.089 0.82 45.089 74.085 0 74.085z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-78.000000, -698.000000) translate(12.000000, 680.000000) translate(66.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#FFCA9A",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0lrflgdxeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jz47ic1l1a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M41.406 50.18l3.16-13.566c.342-1.48.523-3.001.523-4.531V18.447c0-4.151-4.085-7.012-7.91-5.712v-2.28c0-4.282-4.306-7.284-8.281-5.653-1.992-5.422-9.498-5.222-11.32.08-3.864-1.58-8.231 1.28-8.231 5.592V25.05c-2.042-1.37-4.79-1.391-6.883.15-2.677 1.961-3.26 5.712-1.318 8.393l7.068 9.805c1.555 2.157 3.112 4.313 4.672 6.466 1.513 2.087 2.92 3.954 2.92 6.649v16.766c0 .443.366.806.812.806h1.561c.447 0 .812-.363.812-.806V56.364c0-3.467-1.922-6.288-3.918-8.968-1.534-2.06-3.011-4.165-4.513-6.248l-6.797-9.426c-.907-1.26-.634-3.04.613-3.95 1.238-.912 2.978-.641 3.884.62l2.848 3.94c.453.63 1.459.31 1.459-.47V10.474c0-3.8 5.574-3.691 5.574.07V26.43c0 .44.363.8.805.8h.715c.443 0 .805-.36.805-.8V6.843c0-3.802 5.574-3.691 5.574.07V26.42c0 .44.363.8.805.8h.715c.443 0 .805-.36.805-.8V10.384c0-3.801 5.575-3.69 5.575.07V26.43c0 .44.362.8.805.8h.714c.443 0 .805-.36.805-.8v-7.902c0-3.762 5.575-3.882 5.575-.07v13.625h.03c0 1.28-.15 2.56-.443 3.8-.766 3.283-1.408 6.593-2.219 9.863-.693 2.8-1.785 5.528-1.785 8.453v19.077c0 .444.365.807.811.807h1.562c.446 0 .81-.363.81-.807V56.691c0-1.277-.103-2.609.09-3.876.136-.895.486-1.76.711-2.635",
    mask: "url(#0lrflgdxeb)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 3,
    d: "M26 47c-1.73-6.57-5.73-10.237-12-11",
    transform: "translate(20.000000, 8.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#659C8B",
    d: "M50.227 72.36l2.66-5.265 1.222 2.361 3.64.546c.48.004.868-.376.864-.844-.004-.468-.399-.854-.878-.858l-2.563-.537-1.526-2.949c-.326-.63-1.24-.637-1.556-.012l-2.66 5.265-1.1-2.126c-.078-.144-.225-.236-.394-.237l-4.058-.459c-.24-.002-.555.259-.553.493l.007.85c.002.235.2.428.44.43l3.373.382 1.526 2.948c.326.63 1.24.638 1.556.013z",
    transform: "translate(50.969095, 68.581066) scale(-1, 1) rotate(-108.000000) translate(-50.969095, -68.581066)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2783B1",
    d: "M42.468 77.235l2.657-5.266 1.222 2.362 6.63.056c.479.004.867-.376.863-.844-.004-.468-.399-.855-.878-.859l-5.553-.047-1.526-2.95c-.327-.63-1.24-.638-1.556-.013L41.67 74.94l-1.1-2.127c-.078-.144-.226-.236-.394-.237l-3.727-.033c-.24-.002-.433.188-.431.422l.007.851c.002.234.2.428.439.43l2.921.026 1.48 3.008c.325.631 1.287.58 1.603-.045z",
    transform: "translate(44.928791, 73.469426) rotate(-109.000000) translate(-44.928791, -73.469426)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.035e8b7f749adf955d130839249fc943.svg";
export { ForwardRef as ReactComponent };